// Exact phrases (ordered: most specific first so longer matches win)
const DEFAULT_WAKE_PHRASES = [
  // Standard + punctuation variants
  'hey mr berwind',
  'hey, mr berwind',
  'hey mr. berwind',
  'hey, mr. berwind',
  'hey berwind',
  'hey berwind of the elms',
  // Common mis-transcriptions (keep for forgiveness)
  'hey bervind',
  'hey, mr bervind',
  'hey mr. bervind',
  // Common mis-transcriptions
  'hey bervin',
  'hey berwind,',
  'hey mr berwind,',
  'hey mister berwind',
  'hey mister berwind,',
  'hey mrb berwind', // occasional SR glitch
  // "hi" variants (Indian English uses "hi" as naturally as "hey")
  'hi mr berwind',
  'hi, mr berwind',
  'hi mr. berwind',
  'hi berwind',
  // Title variants
  'hey mister berwind',
  'hello mister berwind',
  // "Hello" variants
  'hello mr berwind',
  'hello, mr berwind',
  'hello mr. berwind',
  'hello berwind',
  // "Good morning/afternoon/evening" variants
  'good morning mr berwind',
  'good morning mr. berwind',
  'good morning berwind',
  'good afternoon mr berwind',
  'good afternoon berwind',
  'good evening mr berwind',
  'good evening berwind',
  // Trigger words Chrome produces for "hey" in some accents
  'ok mr berwind',
  'okay mr berwind',
  'hay mr berwind',
  'ok berwind',
  'okay berwind',
];

export function findWakePhrase(text, wakePhrases = DEFAULT_WAKE_PHRASES) {
  const t = String(text || '').toLowerCase();

  // 1. Exact phrase match
  for (const p of wakePhrases) {
    const idx = t.indexOf(p);
    if (idx >= 0) return { phrase: p, idx };
  }

  // 2. Fuzzy phonetic match with strict guardrails.
  //    Keep tolerance for common STT variants, but avoid broad matches
  //    that can trigger during normal conversation.
  const fuzzy = t.match(/\b(hey|hi|hello|ok|okay|hay|good\s+(?:morning|afternoon|evening))\s+(mr\.?\s+|mister\s+)?(berwind|berwin|bervind|bervin)\b/);
  if (fuzzy) {
    return { phrase: fuzzy[0], idx: fuzzy.index };
  }

  return null;
}

export function extractAfterWake(text, wakeMatch) {
  if (!wakeMatch) return '';
  const raw = String(text || '');
  const start = wakeMatch.idx + wakeMatch.phrase.length;
  return raw.slice(start).replace(/^[\s,.:;!?-]+/, '').trim();
}

